﻿import axios, { AxiosError } from 'axios'
import { configuration as config } from '../utils'
import { ApiResponse, ApiCountryResponse, StatusObject, ErrorResponse } from '@/types'

export type CountryOptions = {
  lspApproved: boolean
}

export const fetchCountries = async (
  options?: CountryOptions,
): Promise<StatusObject<ApiCountryResponse['countries']> | StatusObject<null>> => {
  try {
    const queryParams = options?.lspApproved ?? false ? '?lspApproved=true' : ''
    const result: ApiResponse<ApiCountryResponse> = await axios.get(
      config.BASE_API_URL + `/options/countries${queryParams}`,
    )
    return {
      status: true,
      data: result.data.countries.filter((c) => c.countryCode != 'GBD'), // Need to filter out St. Kitts and Nevis
    }
  } catch (error: unknown) {
    const errorMessage =
      error instanceof AxiosError ? (error.response as unknown as ErrorResponse)?.message : (error as Error).message
    return {
      status: false,
      message: errorMessage,
    }
  }
}
